// extracted by mini-css-extract-plugin
module.exports = {"answers":"style_answers__4q2wT","answer":"style_answer__JI5fg","result":"style_result__16l-g","max_correct_answer":"style_max_correct_answer__2KHZ_"};